module.exports = __webpack_public_path__ + "img/logo.4e68a609.svg";